import { useHttp } from '@/api';
import { httpApi } from '@/api/api';

/**
 * 検索入荷基本情報
 */
export function getCheckReceBasicInfo(data) {

  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetCheckReceBasicInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 入荷詳細画面情報の取得
 */
export function getReceDetialSelectInfo(data) {

  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetReceDetialSelectInfo,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 入荷詳細画面選択情報の取得
 */
export function getReceDetialInfoByReceNo(data) {

  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetReceDetialInfoByReceNo,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 注文製品選択情報の取得
 */
export function getReceOrderSelectInfo(data) {

  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetReceOrderSelectInfo,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 検査室入荷情報の取得
 */
export function getReceNoInfo() {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetReceNoInfo)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 検査室入荷情報の新規作成
 */
export function creatReceDeatilInfo(data) {

  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.CreatReceDeatilInfo,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 検査室入荷情報の新規作成
 */
export function creatReceInfo(data) {

  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.CreatReceInfo,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 検査室入荷情報の更新
 */
export function changReceInfo(data) {

  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.ChangeReceInfo,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 検査室入荷情報の削除
 */
export function deleteReceInfo(data) {

  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.DeleteReceInfo,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 入荷チェックリスト出力
 */
export function outCheckList(data) {

  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.OutReceInfoByExcel, null,true)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 入荷詳細画面選択情報の取得(配送単から)
 */
export function searchCheckReceByDeliceryFile(data) {

  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchCheckReceByDeliceryFile, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

